'use es6';

import Immutable from 'immutable';
import ProfileReviewability from 'marketplace-ui-reviews/records/ProfileReviewability';
import { cleanObject } from '../utils/formatters';
import * as Budgets from 'marketplace-ui-solutions-core/constants/Budget';
import OfficeLocation from './OfficeLocation';
import SocialScreenshots from './SocialScreenshots';
const EMPTY_LIST = Immutable.List();
const EMPTY_MAP = Immutable.Map();
const defaults = {
  updatedAt: null,
  updatedByFullName: null,
  budget: Budgets.NONE,
  catalogServices: EMPTY_LIST,
  companySizes: EMPTY_LIST,
  credentials: EMPTY_LIST,
  createdAt: null,
  description: '',
  id: null,
  industries: EMPTY_LIST,
  languages: EMPTY_LIST,
  locations: EMPTY_LIST,
  locationOrder: EMPTY_LIST,
  logoUrl: '',
  name: '',
  partnerType: '',
  portalId: null,
  regions: EMPTY_LIST,
  reviewability: new ProfileReviewability(),
  reviewSummary: EMPTY_MAP,
  slug: '',
  socialScreenshots: new SocialScreenshots(),
  supportedAppOfferings: EMPTY_LIST,
  tier: '',
  websiteUrl: ''
};

class ProfileListing extends Immutable.Record(defaults) {
  static from(json = {}) {
    const values = Object.assign({}, json);

    if (json.locations) {
      if (typeof json.locations === 'object') {
        values.locations = Immutable.List(OfficeLocation.fromArray(json.locations));
      }
    }

    if (values.locations) {
      values.locationOrder = values.locations.map(loc => {
        if (loc instanceof OfficeLocation) {
          return loc.get('full');
        }

        return loc;
      });
    }

    if (json.reviewability) {
      values.reviewability = new ProfileReviewability(json.reviewability);
    }

    if (json.socialScreenshots) {
      values.socialScreenshots = new SocialScreenshots(json.socialScreenshots);
    }

    return new ProfileListing(Immutable.fromJS(cleanObject(values)));
  }

  isEmpty() {
    return Object.keys(defaults).every(key => this.get(key) === defaults[key]);
  }

}

export default ProfileListing;